import React, { useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { useLang } from "../i18n";
import { useAuth } from "../context/AuthContext";
import { Header } from "../components/Header";
import { Button } from "../components/ui/button";
import { toast } from "sonner";
import { Lock } from "lucide-react";

export default function AdminLogin() {
  const { t } = useLang();
  const navigate = useNavigate();
  const location = useLocation();
  const { user, loading } = useAuth();

  useEffect(() => {
    if (location.state?.error) toast.error(location.state.error);
  }, [location.state]);

  useEffect(() => {
    if (!loading && user?.is_admin) navigate("/admin/dashboard", { replace: true });
  }, [user, loading, navigate]);

  const login = () => {
    // REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
    const redirectUrl = window.location.origin + "/admin/dashboard";
    window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirectUrl)}`;
  };

  return (
    <div className="min-h-screen bg-background">
      <Header showAdminLink={false} />
      <div className="max-w-md mx-auto px-4 py-20">
        <div className="bg-card rounded-2xl shadow-sm border border-slate-200/80 p-8 text-center">
          <span className="grid place-items-center w-14 h-14 rounded-xl bg-secondary text-white mx-auto">
            <Lock className="w-6 h-6" />
          </span>
          <h1 className="mt-6 font-display text-2xl font-extrabold text-slate-900">{t("admin.login")}</h1>
          <p className="mt-3 text-sm text-slate-500 leading-relaxed">{t("admin.logindesc")}</p>
          <Button
            onClick={login}
            data-testid="google-login-btn"
            className="mt-8 w-full h-12 bg-primary hover:bg-primary/90 text-base font-semibold"
          >
            {t("admin.google")}
          </Button>
        </div>
      </div>
    </div>
  );
}
